import "./banner/Banner.css";
import Banner from "./banner/Banner";
import About_Shore_Clinic from "./about_shore_clinic/About_Shore_Clinic";
import Our_Doctor from "./our_doctor/Our_Doctor";
import Flag_State from "./flag-state/Flag_State";
import Our_Services from "./our_services/Our_Services";
import Medical_Services from "./medical_services/Medical_Services";
import Why_Choose_Shore from "./why-choose-shore/Why_Choose_Shore";
import Testimonials from "./testimonials/Testimonials";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";
import Blogs_Section from "./blogs/Blogs_Section";

function Home() {
  return (
    <>
      <Banner />
      <About_Shore_Clinic />
      <Our_Doctor />
      {/* <Our_Services /> */}
      <Flag_State />
      {/* <Medical_Services /> */}
      <Why_Choose_Shore />
      <Testimonials />
      {/* <Blogs_Section /> */}
      <Complete_Medical />
    </>
  );
}

export default Home;
